import dayjs from '@shared/dayjs';

const timeWithZoneFormat = 'hh:mm a z';

const formattedTimeFromUtcDateTimeString = (dateTimeString) => {
  return dateTimeString ? dayjs(dateTimeString).tz(Brivity.LocalTimeZone).format(timeWithZoneFormat) : null;
}

const formattedTimeFromUtcTimeString = (timeString) => {
  const utcTimeObject = dayjs.utc(`2017-01-01 ${timeString}`, 'YYYY-MM-DD HH:mm');
  const localTimeObject = utcTimeObject.tz(Brivity.LocalTimeZone);
  return localTimeObject.format(timeWithZoneFormat);
}

export {
  formattedTimeFromUtcDateTimeString,
  formattedTimeFromUtcTimeString,
  timeWithZoneFormat,
};
